export default class DeliverableProcessWebService {
    constructor($sbRequest, API_VERSION) {
        "ngInject";
        this.$sbRequest = $sbRequest;
        this.API_VERSION = API_VERSION;
    }

    /**
     * This endpoint returns components inside a deliverable.
     *
     * @param deliverableId {string}    UUID
     */
    getCollection(deliverableId) {
        const endpointUrl = `/api/${this.API_VERSION}/api/legacy/deliverables/${deliverableId}/components`;
        return this.$sbRequest.json({
            url: endpointUrl,
            method: "GET",
        });
    }
}
